import React, { Fragment, Component } from 'react'
import { observer } from 'mobx-react'

const schema = 'explori_v3'
const baseURL = `/intranet/dataviewer?schema${schema}`
const target = '_blank'

@observer
class DebugInfo extends Component {
    questionLink = () => {
        const { questionId, store } = this.props
        return (
            <div>
                QuestionId: [
                <a
                    target={target}
                    href={`${baseURL}&tablename=question_sets_options&f1=questionid&op1=eq&val1=${questionId}&viewdata=true`}
                >
                    {questionId}
                </a>
                ]
                <i
                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                    className="fal fa-copy"
                    onClick={() => store.copyText(questionId, 'QuestionId')}
                />
            </div>
        )
    }

    pageQuestionLink = () => {
        const { pageQuestionId, store } = this.props
        return (
            <div>
                PageQuestionId: [
                <a
                    target={target}
                    href={`${baseURL}&tablename=survey_page_question&f1=pagequestionid&op1=eq&val1=${pageQuestionId}&viewdata=true`}
                >
                    {pageQuestionId}
                </a>
                ]
                <i
                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                    className="fal fa-copy"
                    onClick={() => store.copyText(pageQuestionId, 'PageQuestionId')}
                />
            </div>
        )
    }

    surveyDataLink = () => {
        const { pageQuestionId, store, hideDataLink } = this.props
        const { clientId } = store.userData

        if (hideDataLink) return null

        return (
            <div>
                <a
                    target={target}
                    href={`/intranet/dataviewer?schema=explori_v3_clientid_${clientId}&tablename=surveydataopt&f1=pagequestionid&op1=eq&val1=${pageQuestionId}&viewdata=true`}
                >
                    SurveyData
                </a>
            </div>
        )
    }

    questionType = () => {
        const { questionTypeCode } = this.props
        return (
            <div>
                type: [{questionTypeCode}]
            </div>
        )
    }

    cloneLink = () => {
        const { pageQuestionId, hideCloneLink } = this.props

        if (hideCloneLink) return null

        return (
            <div>
                <a
                    href={`/intranet/cloneThenRestoreQuestion?pagequestionid=${pageQuestionId}6&verifyonly=true`}
                    target={target}
                >
                    [Clone Then Restore]
                </a>
            </div>
        )
    }

    render() {
        const { store } = this.props
        return (
            store.showDebug
                ? (
                    <div className="debugInfo">
                        {this.questionType()}
                        {this.surveyDataLink()}
                        {this.cloneLink()}
                        {this.questionLink()}
                        {this.pageQuestionLink()}
                    </div>
                ) : null
        )
    }
}

export default DebugInfo
